class LanmotionBundleCart extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    delete this.dataset.initialized;
  }

  handleClick(event) {
    const minusButton = event.target.closest('[data-bundle-minus]');
    const plusButton = event.target.closest('[data-bundle-plus]');
    const removeButton = event.target.closest('[data-bundle-remove]');
    if (!minusButton && !plusButton && !removeButton) return;

    event.preventDefault();
    const currentQuantity = Number(this.dataset.bundleQuantity || 1);
    let nextQuantity = currentQuantity;

    if (removeButton) nextQuantity = 0;
    if (minusButton) nextQuantity = Math.max(0, currentQuantity - 1);
    if (plusButton) nextQuantity = currentQuantity + 1;

    if (nextQuantity !== currentQuantity) this.updateBundle(nextQuantity);
  }

  async updateBundle(nextQuantity) {
    if (this.dataset.updating === 'true') return;

    const bundleItems = [...this.querySelectorAll('[data-bundle-item]')];
    const errorElement = this.querySelector('[data-bundle-error]');
    const updates = {};

    bundleItems.forEach((item) => {
      const key = item.dataset.bundleItemKey;
      const ratio = Number(item.dataset.bundleItemRatio || 1);
      if (key) updates[key] = nextQuantity * ratio;
    });

    if (!Object.keys(updates).length) return;

    this.dataset.updating = 'true';
    this.classList.add('is-loading');
    this.querySelectorAll('button').forEach((button) => { button.disabled = true; });
    if (errorElement) errorElement.textContent = '';

    const root = window.Shopify?.routes?.root || '/';
    const updateUrl = window.routes?.cart_update_url || `${root}cart/update.js`;

    try {
      const response = await fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          updates,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });

      const cartData = await response.json();
      if (!response.ok || cartData.status) {
        throw new Error(cartData.description || cartData.message || 'Unable to update this kit.');
      }

if (this.dataset.bundleContext === 'page') {
  window.location.reload();
  return;
}

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && cartData.sections) {
        drawer.renderContents(cartData, true);
      } else {
        window.location.reload();
        return;
      }

      document.dispatchEvent(new CustomEvent('cartQuantityUpdated', {
        detail: { handle: 'lanmotion-kit' }
      }));
    } catch (error) {
      this.dataset.updating = 'false';
      this.classList.remove('is-loading');
      this.querySelectorAll('button').forEach((button) => { button.disabled = false; });
      if (errorElement) errorElement.textContent = error.message;
    }
  }
}

if (!customElements.get('lanmotion-bundle-cart')) {
  customElements.define('lanmotion-bundle-cart', LanmotionBundleCart);
}
